import PropTypes from 'prop-types';

import { MenuItem, Typography } from '@mui/material';

const MenuItemComponent = ({
  label,
  onClick,
  disabled,
  color,
  handleClose,
}) => (
  <MenuItem
    onClick={(event) => {
      event?.preventDefault();
      event?.stopPropagation();
      onClick();
      handleClose();
    }}
    disabled={disabled}
  >
    <Typography style={color ? { color } : {}}>{label}</Typography>
  </MenuItem>
);

MenuItemComponent.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  onClick: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
};

export default MenuItemComponent;
